import { z } from 'zod';

const emailSchema = z
  .string()
  .email('البريد الإلكتروني غير صحيح')
  .toLowerCase()
  .trim();

const passwordSchema = z
  .string()
  .min(8, 'كلمة المرور يجب أن تكون 8 أحرف على الأقل')
  .regex(/[A-Z]/, 'يجب أن تحتوي على حرف كبير واحد على الأقل')
  .regex(/[0-9]/, 'يجب أن تحتوي على رقم واحد على الأقل');

export const loginSchema = z.object({
  email:    emailSchema,
  password: z.string().min(1, 'كلمة المرور مطلوبة'),
});

export const registerSchema = z
  .object({
    name:             z.string().min(3, 'الاسم يجب أن يكون 3 أحرف على الأقل').trim(),
    email:            emailSchema,
    phone:            z.string().min(10, 'رقم الجوال غير صحيح').trim().optional().or(z.literal('')),
    dept_id:          z.string().uuid('يرجى اختيار القسم').optional().or(z.literal('')),
    title:            z.string().min(2, 'المسمى الوظيفي مطلوب').trim().optional().or(z.literal('')),
    password:         passwordSchema,
    confirm_password: z.string(),
  })
  .refine((d) => d.password === d.confirm_password, {
    message: 'كلمات المرور غير متطابقة',
    path: ['confirm_password'],
  });

export const resetPasswordRequestSchema = z.object({
  email: emailSchema,
});

export const confirmResetPasswordSchema = z
  .object({
    token:            z.string().min(1),
    new_password:     passwordSchema,
    confirm_password: z.string(),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    message: 'كلمات المرور غير متطابقة',
    path: ['confirm_password'],
  });

export type LoginInput    = z.infer<typeof loginSchema>;
export type RegisterInput = z.infer<typeof registerSchema>;
export type ResetInput    = z.infer<typeof resetPasswordRequestSchema>;
export type ConfirmResetInput = z.infer<typeof confirmResetPasswordSchema>;
